import { useState } from "react";
import {
  GameClubAllHeader,
  GameClubAllWrapper,
} from "../Style/GameClubAllStyles";
import { GameClubAllList } from "./GameClubAllList";

export const GameClubAll = () => {
  const [search, setSearch] = useState<string>("");
  return (
    <GameClubAllWrapper>
      <GameClubAllHeader>
        <div className="input-box">
          <input
            type="text"
            placeholder="찾고 있는 우리 동네 클럽은? 지금 바로 검색!"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <img src="/image-web/game/club/search_icon.svg" alt="검색" />
        </div>
      </GameClubAllHeader>
      <GameClubAllList search={search} />
    </GameClubAllWrapper>
  );
};
